// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { useResizeObserver } from '@/hooks/use-resize-observer';
import { useRef } from 'react';

/**
 * A React hook that returns a ref and a resize observer attached to the ref.
 */
export function useResizeObserverRef<T extends HTMLElement = HTMLElement>() {
  const ref = useRef<T>(null);
  const resizeObserver = useResizeObserver(ref);

  return { ref, ...resizeObserver };
}
